import { EyeClosedIcon } from './EyeClosedIcon';

/**
 * author: joshua-maros
 * id 81421142-BE10-4918-8720-5858B7BC2E4B
 * name eye-closed
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-closed.svg
 * tags
 */
export const EyeShutIcon = EyeClosedIcon;
export default EyeShutIcon